import { render, staticRenderFns } from "./RezervirovanieList.vue?vue&type=template&id=178ad148&"
import script from "./RezervirovanieList.vue?vue&type=script&lang=js&"
export * from "./RezervirovanieList.vue?vue&type=script&lang=js&"
import style0 from "./RezervirovanieList.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/vagrant/interfaces/online/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VDivider,VFlex,VIcon,VLayout})
